import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteConstants } from '../../../../../core/constants/api-routes';

@Injectable({
    providedIn: 'root',
})
export class WelcomeBannerService {
    private readonly welcomeBannerApiRoute = ApiRouteConstants.User;

    constructor(private readonly http: HttpClient) {}

    getWelcomeBannerStatus(userId: number): Observable<boolean> {
        return this.http.get<boolean>(
            this.welcomeBannerApiRoute.getWelcomeBannerStatusUrl(userId),
        );
    }

    hideWelcomeBanner(userId: number): Observable<void> {
        return this.http.post<void>(
            this.welcomeBannerApiRoute.disableWelcomeBannerUrl(userId),
            {},
        );
    }
}
